import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AllPreviewComps from '../index';
let BaseNav = class BaseNav extends Vue {
    constructor() {
        super(...arguments);
        this.activeIndex = 0;
        this.slideLeft = 0;
        this.initX = 0;
        this.initY = 0;
        this.useCenter = false;
        this.divOffsetT = 0;
        this.isHanderActive = false;
        // 非通用属性
        this.activeCompKey = '';
        this.liftEl = null;
        this.liftElCopy = null;
        this.conWrap = null;
        this.allJumpEl = [];
        this.needScrollValue = 0;
    }
    onClassifyChange(val) {
        if (val &&
            typeof this.activeIndex === 'number' &&
            this.activeIndex >= val) {
            this.activeHandler(null, 0, null);
        }
        this.setScroll();
    }
    onFontAlignChange(val) {
        if (val) {
            this.setScroll();
        }
    }
    get navList() {
        return this.data.lifts || [];
    }
    get navTitle() {
        // ${this.data.navType ? '' : 'position: sticky; top: 0;'}
        return `${this.navBgStyle};
      ${this.useCenter ? 'justify-content: center;' : ''}`;
    }
    get navbarStyle() {
        return `--activeAfter: ${this.data.fontColor}`;
    }
    get navBgStyle() {
        return `background: ${this.data.bgColor || '#00B097'}`;
    }
    get getComp() {
        return item => {
            let compName = item.type.substr(0, 1).toUpperCase() + item.type.substr(1) || 'Empty';
            return AllPreviewComps[compName];
        };
    }
    get activeColor() {
        return `--activeColor: ${this.data.activeColor || '#00B097'}`;
    }
    mounted() {
        this.setScroll();
        this.data.navType === 0 && this.bindXid();
        this.liftEl = document.querySelector('.preview-lift');
        this.liftElCopy = document.querySelector('.preview-lift-copy');
        this.conWrap = document.querySelector('.preview-box');
        this.allJumpEl = this.data.lifts.map(item => document.querySelector(`[data-item-id=${item._id}]`));
    }
    scrollFn() {
        let top = this.conWrap.scrollTop;
        this.divOffsetT = this.liftEl.offsetTop || this.liftElCopy.offsetTop;
        if (top > this.divOffsetT) {
            this.liftEl.setAttribute('style', 'position: fixed; top: 0px; z-index: 999');
            this.liftElCopy.setAttribute('style', 'display: block;');
        }
        else {
            this.liftEl.setAttribute('style', 'position: static;');
            this.liftElCopy.setAttribute('style', 'display: none;');
        }
        // 滚动完成
        if (!this.isHanderActive) {
            let allEleTop = this.allJumpEl.map(el => {
                if (el) {
                    let { top } = el.getBoundingClientRect();
                    return top;
                }
                else {
                    return 99999999;
                }
            });
            let offHeight = this.liftEl.offsetHeight;
            let oldDiff = 999999;
            let findIndex = null;
            allEleTop.forEach((el, idx) => {
                let newDiff = offHeight - el;
                if (Math.abs(newDiff) < Math.abs(oldDiff)) {
                    oldDiff = Math.abs(newDiff);
                    findIndex = idx;
                }
            });
            this.activeIndex = findIndex;
            // if (this.liftEl.offsetTop > top) {
            //   this.activeIndex = 0
            // }
            // for (let index = 0; index < this.allJumpEl.length; index++) {
            //   const el = this.allJumpEl[index]
            //   let { top } = el.getBoundingClientRect()
            //   console.log('===', index, top, this.liftEl.offsetHeight)
            //   if (top < this.liftEl.offsetHeight) {
            //     this.activeIndex = index
            //   }
            // }
            if (this.liftEl.offsetTop > top) {
                this.activeIndex = 0;
            }
        }
        if (top === this.needScrollValue) {
            this.isHanderActive = false;
        }
    }
    bindXid() {
        let conWrap = document.querySelector('.preview-box');
        conWrap && conWrap.addEventListener('scroll', this.scrollFn);
    }
    beforeDestroy() {
        let conWrap = document.querySelector('.preview-box');
        conWrap && conWrap.removeEventListener('scroll', this.scrollFn);
    }
    async activeHandler(item, index, $event) {
        this.isHanderActive = true;
        this.activeIndex = index;
        const _self = this;
        let liftEl = document.querySelector('.preview-lift-title');
        if (item) {
            let selEl = document.querySelector(`[data-item-id=${item._id}]`);
            if (selEl) {
                let height = liftEl.offsetHeight;
                let topValue = selEl.offsetTop - (this.data.navType === 0 ? height : 0);
                // this.conWrap.scrollTop = topValue + 1
                this.needScrollValue = topValue + 1;
                this.scrollMove(topValue + 1);
                setTimeout(() => {
                    _self.isHanderActive = false;
                }, 400);
                // if (this.conWrap.scrollTo) {
                //   this.conWrap.scrollTo({
                //     top: topValue,
                //     behavior: 'smooth',
                //   })
                // } else {
                //   this.conWrap.scrollTop = topValue
                // }
            }
        }
        if ($event) {
            let cEl = $event.currentTarget;
            await this.$nextTick();
            let liWidth = cEl.scrollWidth;
            let screenWidth = window.screen.width;
            let diffNum = Math.floor((screenWidth - liWidth) / 2);
            let left = cEl.offsetLeft - diffNum;
            let navUl = this.$el.querySelector('.group-title');
            navUl.scrollTo({
                left: left,
                behavior: 'smooth',
            });
        }
    }
    scrollMove(v) {
        let targetPosition = v; // 滚动到距离顶部100像素的位置
        let duration = 300; // 滚动动画的持续时间（毫秒）
        let startTime = null; // 动画开始时间
        const self = this;
        let top = this.conWrap.scrollTop;
        if (top === v) {
            return;
        }
        function scrollTo(timestamp) {
            if (!startTime)
                startTime = timestamp;
            let progress = timestamp - startTime;
            let position = null;
            if (top > targetPosition) {
                let diff = top - targetPosition;
                position = Math.min(top - (progress / duration) * diff, top);
                if (position < targetPosition) {
                    position = targetPosition;
                }
                // console.log(
                //   'rrrr1',
                //   top,
                //   targetPosition,
                //   (progress / duration) * diff,
                //   position
                // )
            }
            else {
                let diff2 = targetPosition - top;
                position = Math.min((progress / duration) * diff2 + top, targetPosition);
                if (position > targetPosition) {
                    position = targetPosition;
                }
                // console.log(
                //   'rrrr2',
                //   top,
                //   targetPosition,
                //   (progress / duration) * diff2,
                //   position
                // )
            }
            self.conWrap.scrollTop = position;
            if (progress < duration) {
                window.requestAnimationFrame(scrollTo);
            }
        }
        window.requestAnimationFrame(scrollTo);
    }
    /**
     * 以下为组件非通用部分，不删除不影响c端交互
     */
    activeComp(type, data, activeCompKey) {
        if (activeCompKey) {
            this.activeCompKey = `${activeCompKey.index}-${activeCompKey.key}`;
        }
        else {
            this.activeCompKey = '';
        }
        this.$emit('compActive', type, data);
    }
    async setScroll() {
        await this.$nextTick();
        let $domEl = this.$refs['grouptitle'];
        let screenWidth = window.screen.width;
        if (this.data.fontAlign === 'center') {
            let left = ($domEl.scrollWidth - $domEl.offsetWidth) / 2;
            $domEl.scrollLeft = left;
            this.useCenter = $domEl.scrollWidth <= screenWidth ? true : false;
        }
        else {
            $domEl.scrollLeft = 0;
            this.useCenter = false;
        }
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], BaseNav.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], BaseNav.prototype, "preview", void 0);
tslib_1.__decorate([
    Watch('navList.length')
], BaseNav.prototype, "onClassifyChange", null);
tslib_1.__decorate([
    Watch('data.fontAlign')
], BaseNav.prototype, "onFontAlignChange", null);
BaseNav = tslib_1.__decorate([
    Component({})
], BaseNav);
export default BaseNav;
